// extracted by mini-css-extract-plugin
module.exports = {"introText":"page-intro-module--intro-text--2M6jZ","contentRow":"page-intro-module--content-row--2gYCa","heading":"page-intro-module--heading--2clEJ"};